import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PatientFlag } from '@/types/patient-chart-api';

/**
 * Patient flags list — Chart > Flags tab (PROD-736 PR E).
 *
 * Wire (Flutter `patient_chart_data_source_impl.dart:624`):
 *
 *   GET /api/Patients/GetFlagByPatientId?PatientId={id}
 *       → PatientFlag[]
 *
 * Distinct from the patient-list "flags" feature (already shipped in
 * scheduling `usePatientFlags` for the calendar row warning strip).
 * That one returns scheduling-context flags; this returns the full
 * clinical / social flag set bound to the patient chart.
 */

export function usePatientFlagsChart(patientId: string | null | undefined) {
  return useQuery({
    queryKey: ['patient-flags-chart', patientId],
    queryFn: ({ signal }) => {
      const qs = new URLSearchParams({ PatientId: patientId ?? '' });
      return get<PatientFlag[]>(
        `/api/Patients/GetFlagByPatientId?${qs.toString()}`,
        { signal },
      );
    },
    enabled: !!patientId,
    staleTime: 60_000,
  });
}
